import { useEffect, useState } from "react";
import { toast } from "sonner";
import { format } from "date-fns";
import { Syringe } from "lucide-react";
import api from "@/lib/api";
import { DeleteButton } from "@/components/DeleteButton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";

export default function AdminGlpLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { load(); }, []);
  async function load() { try { const { data } = await api.get("/glp-reminders"); setItems(data); } catch { /* */ } }

  async function toggle(item) {
    try {
      await api.patch(`/glp-reminders/${item.id}`, { reordered: !item.reordered });
      setItems((list) => list.map((i) => (i.id === item.id ? { ...i, reordered: !i.reordered } : i)));
      toast.success(!item.reordered ? "Marked as reordered." : "Marked as not reordered.");
    } catch { toast.error("Failed."); }
  }

  async function del(id) {
    try { await api.delete(`/glp-reminders/${id}`); setItems((list) => list.filter((i) => i.id !== id)); toast.success("Entry deleted."); }
    catch { toast.error("Failed to delete."); }
  }

  const pending = items.filter((i) => !i.reordered).length;

  return (
    <div>
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary"><Syringe className="h-6 w-6" /></div>
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">GLP / Insulin Reorder Log</h1>
          <p className="text-sm text-muted-foreground">Every GLP/insulin refill delivered. Check off each one once you've reordered stock.</p>
        </div>
      </div>

      <div className="mt-4"><Badge className={pending ? "bg-orange-500" : "bg-primary"}>{pending} awaiting reorder</Badge></div>

      <div className="mt-4 overflow-hidden rounded-xl border border-border/60 bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Delivered</TableHead><TableHead>Medication</TableHead><TableHead>Patient</TableHead>
              <TableHead className="text-center">Reordered</TableHead><TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="py-10 text-center text-muted-foreground">No GLP/insulin refills logged yet.</TableCell></TableRow>
            ) : items.map((it) => (
              <TableRow key={it.id} data-testid={`glp-row-${it.id}`} className={it.reordered ? "opacity-60" : ""}>
                <TableCell className="whitespace-nowrap text-sm">{format(new Date(it.created_at), "MMM d, yyyy h:mm a")}</TableCell>
                <TableCell className="font-medium">{it.medication}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{it.patient_name || "—"}</TableCell>
                <TableCell className="text-center">
                  <Checkbox checked={!!it.reordered} onCheckedChange={() => toggle(it)} data-testid={`glp-reordered-${it.id}`} />
                </TableCell>
                <TableCell className="text-right"><DeleteButton onConfirm={() => del(it.id)} label="this reorder entry" testId={`glp-delete-${it.id}`} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
